module.exports = __webpack_public_path__ + "static/media/one_million_arab_coder_logo.6d35e2b0.jpg";